import ElementUI from 'element-ui'
import Vue from 'vue'
// import { Message } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import myComponent from "./components"
import router from './router'
import store from './store'


Vue.use(ElementUI);
// Vue.use(Message);
Vue.use(myComponent);
Vue.config.productionTip = false

function normalizeLegacyHashUrl () {
  // Backward-compatible: convert legacy hash URLs like /#/path?x=1 to history URLs.
  if (window.location.hash && window.location.hash.startsWith('#/')) {
    const normalizedPath = window.location.hash.slice(1)
    window.history.replaceState(null, '', normalizedPath)
  }
}

normalizeLegacyHashUrl()
window.addEventListener('hashchange', normalizeLegacyHashUrl)

Vue.filter('translateWidth', function (number) {
  if(document.body.clientWidth) {
    return (number / 1920) * document.body.clientWidth
  } else {
    return number
  }
})

if (process.env.NODE_ENV === 'development') {
  (function(c,l,a,r,i,t,y){
    c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
    t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
    y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
  })(window, document, "clarity", "script", "w46m2ymcsh");
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')